// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"412aae82","361":"ad694248","511":"912de541","767":"ef0fc652"}[chunkId] + ".chunk.js";
};